;(function() {
  'use strict'

  Factory.$inject = ["$q", "glPrefs", "usersResource"];
  angular.module('core.factories').factory('TransientStorage', Factory)

  /* @ngInject */
  function Factory($q, glPrefs, usersResource) {
    var prefs = glPrefs.create('TransientStorage')
    var AutocompletePrefPrefix = 'autocomplete'

    /**
     * @class TransientStorage
     * @desc instantiates a new transient storage
     */
    function TransientStorage() {
      this.identity = 'device'
      this.profileQuestions = {}
    }

    /**
     * get
     * @desc gets a profile question's answer
     * @param {String} key - the profile question's key
     * @return {Object} answer - the profile question's answer
     */
    TransientStorage.prototype.get = function(key) {
      if (!key) {
        return
      }

      var prefKey = this.prefKey(key)

      return prefs.get(prefKey)
    }

    /**
     * update
     * @desc updates a profile question's data
     * @param {String} key - the profile question's key
     * @param {Object} value - the answer to save
     */
    TransientStorage.prototype.update = function(key, value) {
      this.profileQuestions[key] = value
    }

    /**
     * save
     * @desc saves the user's profile question answers to local storage and the BE if required
     */
    TransientStorage.prototype.save = function() {
      var self = this

      self.saveToDevice()

      if (self.emailUserAuth) {
        self.saveToUser()
      }
    }

    TransientStorage.prototype.saveToDevice = function() {
      var self = this
      _.each(self.profileQuestions, function(value, key) {
        var prefKey = self.prefKey(key)
        prefs.set(prefKey, value)
      })
    }

    TransientStorage.prototype.saveToUser = function() {
      var self = this
      var auth = self.emailUserAuth
      return $q(function(resolve, reject) {
        usersResource
          .me(null, null, auth)
          .success(function(x, user) {
            // ensure we have the profile questions data path
            user.data = _.isPlainObject(user.data) ? user.data : {}
            user.data.profileQuestions = _.isPlainObject(
              user.data.profileQuestions
            )
              ? user.data.profileQuestions
              : {}

            _.assign(user.data.profileQuestions, self.profileQuestions)

            usersResource
              .updateCurrent(user, null, auth)
              .success(resolve)
              .error(reject)
          })
          .error(reject)
      })
    }

    TransientStorage.prototype.removeFromDevice = function() {
      var self = this
      _.each(self.profileQuestions, function(value, key) {
        var prefKey = self.prefKey(key)
        prefs.set(prefKey, null)
      })
    }

    /**
     * prefKey
     * @desc adds a prefix to the question key
     * @param {String} key - the profile question's key
     * @returns {String} prefKey - the prefixed key for local storage
     */
    TransientStorage.prototype.prefKey = function(key) {
      return AutocompletePrefPrefix + '/' + key
    }

    return TransientStorage
  }
})()
